<template>
  <v-dialog
    v-if="dialog"
    v-model="editDialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="cancelAction"
  >
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading || !pdfSource">
      <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>
    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{pdfTitle}}</span>
        <v-spacer></v-spacer>
        <v-btn
          text
          icon
          title="Cancelar"
          class="my-2"
          @click="cancelAction"
        >
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 px-3 px-sm-4 px-md-6">
        <v-alert
          type="error"
          elevation="2"
          v-if="formErrors.length > 0"
          dismissible
        >
          <p 
            v-for="error in formErrors" 
            class="mb-0"
            :key="error">
            {{error}}
          </p>
        </v-alert>

        <pdf v-for="i in pdfNumPages" :key="i" :page="i" :src="pdfSource"></pdf>

        <slot name="editForm"></slot>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-btn class="my-2" @click="cancelAction">
          {{editCancelButtonLabel}}
        </v-btn>

        <v-spacer></v-spacer>
        
        <!-- <slot name="action1"></slot>
        <slot name="action2"></slot>
        <slot name="action3"></slot>

        <v-btn color="success" class="my-2" @click="confirmAction" v-if="!readOnly">
          {{editSaveButtonLabel}}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn> -->
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipDownload }">
            <a style="text-decoration: none;"
              :href="pdfSource"
              :download="pdfTitle + '.pdf'"
            > 
              <v-btn v-on="{ ...tooltipDownload }">
                Download
                <v-icon
                  small
                  class="mr-2"
                  right
                >
                  mdi-download
                </v-icon>
              </v-btn>
            </a>
          </template>
          <span>{{'Download do arquivo ' + pdfTitle + '.pdf'}}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on: dialog }" >
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
        <v-icon
          v-on="{ ...tooltip, ...dialog }"
          class="mx-1"
          @click="openAction"
        >
        <!-- :title="editButtonLabel" -->
          <!-- mdi-file-eye -->
          mdi-file-pdf
        </v-icon>
        </template>
        <span>{{'Visualizar ' + pdfTitle}}</span>
      </v-tooltip>
    </template>
  </v-dialog>  
</template>

<script>
import pdf from 'vue-pdf'

export default {
  data() {
    return {
      editDialog: null,
      // src: loadingTask,
      // numPages: 1,
    };
  },
  mounted() {
    //nao consegui pegar o numero de paginas do pdf !!!
    // var loadingTask = pdf.createLoadingTask(this.pdfSource);
    // loadingTask.promise.then(pdf => {
    // this.numPages = pdf.numPages;
    // console.log("numPages: "+ this.numPages);
  // });
},
  props: {
    pdfSource: {
      type: String
    },
    pdfNumPages: {      
      default: 1,
    },
    nestedDialog: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: true
    },
    formErrors: {
      type: Array,
      default: () => []
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    pdfTitle: {
      type: String,
      default: "Visualização de arquivo PDF"
    },
    editButtonLabel: {
      type: String,
      default: "Editar"
    },
    editCancelButtonLabel: {
      type: String,
      default: "Cancelar"
    },
    editSaveButtonLabel: {
      type: String,
      default: "Salvar Alterações"
    },
    loading: {
      type: Boolean,
      default: true
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    }
  },
  components: {
    pdf,
  },
  methods: {
    cancelAction: function(){
      this.editDialog = false
      this.$emit("edit-cancel-action")
    },
    confirmAction: function(){
      this.$emit("edit-confirm-action")
    },
    openAction: function() {
      this.$emit("pdf-open-action")
    },
    closeDialog: function() {
      this.editDialog = false;
    },
  },
};
</script>

<style scoped></style>
